<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex class="d-flex align-center" xs12>
          <h1 class="headline">{{ $t('finance.configurator') }}</h1>

          <v-btn
            class="ml-auto"
            color="warning"
            elevation="0"
            large
            @click="
              () => {
                dialog.opened = true;
                dialog.typeId = null;
                dialog.name = null;
                dialog.categoryId = null;
              }
            "
          >
            {{ $t('finance.expenceTypeAdd') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex class="mt-5" xs12>
      <v-data-table
        ref="configuratorTable"
        class="configurator-table"
        :items-per-page="-1"
        :headers="headers"
        :items="list"
        :loading="loading"
        :height="tableHeight"
        hide-default-footer
      >
        <template #item="{ item }">
          <tr>
            <td width="50px">{{ item.num }}</td>
            <td width="200px">
              <button
                class="edit-btn"
                @click="
                  () => {
                    dialog.opened = true;
                    dialog.typeId = item.id;
                    dialog.name = item.name;
                    dialog.categoryId = null;
                  }
                "
              >
                {{ item.name }}
              </button>
            </td>
            <td>
              <ul class="configurator__categories">
                <li v-for="(category, idx) in item.categories" :key="idx">
                  <v-chip
                    color="green white--text"
                    small
                    label
                    @click="
                      () => {
                        dialog.opened = true;
                        dialog.typeId = item.id;
                        dialog.name = category.name;
                        dialog.categoryId = category.id;
                      }
                    "
                  >
                    {{ category.name }}
                  </v-chip>
                </li>

                <li>
                  <v-chip
                    color="green white--text"
                    v-ripple
                    outlined
                    small
                    label
                    @click="
                      () => {
                        dialog.opened = true;
                        dialog.typeId = item.id;
                        dialog.name = null;
                        dialog.categoryId = null;
                      }
                    "
                  >
                    <v-icon size="16">mdi-plus</v-icon>
                  </v-chip>
                </li>
              </ul>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>

    <configurator-dialog
      v-model="dialog.opened"
      :type-id="dialog.typeId"
      :category-id="dialog.categoryId"
      :current-name="dialog.name"
      @updated="fetchList"
    />
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import ConfiguratorDialog from '@/components/finance/company-expenses/ConfiguratorDialog.vue';
import calcTableHeight from '@/helpers/calcTableHeight';
import checkRouteAccess from '@/helpers/checkRouteAccess';

export default {
  beforeRouteEnter(to, from, next) {
    checkRouteAccess('finance_expanse_config_view', next);
  },
  components: { ConfiguratorDialog },
  data: () => ({
    loading: false,
    dialog: {
      opened: false,
      typeId: null,
      name: null,
      categoryId: null,
    },
    tableHeight: 'auto',
  }),
  computed: {
    ...mapState({
      list: (state) => state['company-expenses'].configuratorList,
    }),
    headers() {
      return [
        { text: this.$t('common.number'), sortable: false },
        { text: this.$t('finance.expenceType'), sortable: false },
        { text: this.$t('finance.categories'), sortable: false },
      ];
    },
  },
  methods: {
    async fetchList() {
      this.loading = true;
      await this.$store.dispatch('company-expenses/fetchConfiguratorList');
      this.loading = false;
    },
  },
  created() {
    this.fetchList();
  },
  mounted() {
    const table = this.$refs.configuratorTable;
    this.tableHeight = calcTableHeight(table.$el);
  },
};
</script>

<style lang="scss">
.configurator-table {
  margin-top: 20px;

  thead {
    position: sticky;
    top: 0;
    z-index: 1;
  }
}
.configurator__categories {
  padding: 10px 0 !important;

  li {
    list-style: none;
    margin-bottom: 5px;

    .v-chip {
      text-align: center;
      user-select: none;
      cursor: pointer;
    }
  }
}

.edit-btn {
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.3;
  text-decoration: none;

  &[disabled] {
    font-weight: normal;
  }

  &:not([disabled]):hover {
    opacity: 0.7;
  }
}

.v-expansion-panel-content {
  background-color: #f2f2f2;
}
</style>
